import { React, useState, useEffect } from "react";
import {
  getFirestore,
  collection,
  doc,
  getDocs,
  updateDoc,
  deleteDoc,
  query,
  where,
} from "firebase/firestore";
import {
  getStorage,
  ref,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { PhotoProvider } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import Modal from "react-bootstrap/Modal"; // Importar el Modal de react-bootstrap
import "./Styles/SVComponents.css";

function SVShowPhotoGallery({ show, isValidateView }) {
  const [photos, setPhotos] = useState([]);
  const [currentImage, setCurrentImage] = useState(null); // Controlamos la imagen actual seleccionada
  const [isModalOpen, setIsModalOpen] = useState(false);

  const db = getFirestore();
  const storage = getStorage();

  useEffect(() => {
    const fetchPhotos = async () => {
      const photosCollection = collection(db, `Shows/${show.id}/Photos`);
      const queryPhotosCollection = query(
        photosCollection,
        where("isValidated", "==", !isValidateView)
      );
      const photoDocs = await getDocs(queryPhotosCollection);
      const fetchedPhotos = [];

      for (const doc of photoDocs.docs) {
        const photoData = doc.data();

        const storageRef = ref(
          storage,
          `showPhotos/${show.season}/${show.id}/${doc.id}`
        );
        const url = await getDownloadURL(storageRef);

        // Obtener las dimensiones originales de las imágenes
        const img = new Image();
        img.src = url;

        await new Promise((resolve) => {
          img.onload = () => {
            const width = img.width;
            const height = img.height;

            fetchedPhotos.push({
              id: doc.id,
              src: url,
              width: width,
              height: height,
              description: photoData.description,
            });

            resolve();
          };
        });
      }

      setPhotos(fetchedPhotos);
    };

    fetchPhotos();
  }, [db, storage, show.id, show.season, isValidateView]);

  // Abrir modal con imagen seleccionada
  const openModal = (event, { image }) => {
    setCurrentImage(image); // Almacenar la imagen seleccionada
    setIsModalOpen(true);
  };

  const validarImagen = async (photoId) => {
    try {
      const photoRef = doc(db, `Shows/${show.id}/Photos`, photoId);
      await updateDoc(photoRef, { isValidated: true });
    } catch (error) {}
    setIsModalOpen(false);
    window.location.reload();
  };

  const descartarImagen = async (image) => {
    try {
      const storageRef = ref(
        storage,
        `showPhotos/${show.season}/${show.id}/${image.id}`
      );
      await deleteObject(storageRef);
      const photoRef = doc(db, `Shows/${show.id}/Photos`, image.id);
      await deleteDoc(photoRef);
    } catch (error) {}
    setIsModalOpen(false);
    window.location.reload();
  };

  // Cerrar modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <PhotoProvider
        maskOpacity={0.7}
        speed={() => 500}
        easing={(type) => (type === 2 ? "ease-in" : "ease-out")}
      >
        <div
          className="d-flex flex-wrap gap-2"
          style={{ justifyContent: "center" }}
        >
          {photos.map((img, i) => (
            <img
              src={img.src}
              alt={img.alt}
              onClick={(e) => openModal(e, { image: img })}
              style={{ cursor: "pointer", width: "150px", borderRadius: "8px" }}
            />
          ))}
        </div>
      </PhotoProvider>

      <Modal
        show={isModalOpen}
        onHide={closeModal}
        centered
        size="lg"
        className="custom-modal"
      >
        <Modal.Body>
          {currentImage && (
            <>
              <div className="image-container">
                <img
                  src={currentImage.src}
                  alt={currentImage.description || "Imagen"}
                  className="img-fluid"
                />
                <div className="image-description">
                  {currentImage.description}
                </div>
              </div>
              {isValidateView && (
                <>
                  <div>
                    <button
                      className="btn btn-primary mt-3 mr-3 boton-redCorporative"
                      onClick={() => validarImagen(currentImage.id)}
                    >
                      Validar
                    </button>

                    <button
                      className="btn btn-primary mt-3 mr-3 boton-redCorporative"
                      onClick={() => descartarImagen(currentImage)}
                    >
                      Descartar
                    </button>
                  </div>
                </>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default SVShowPhotoGallery;
